import ComplexTextWidgetEditor from './ComplexTextWidgetEditor.vue';
import ComplexTextWidgetView from './ComplexTextWidgetView.vue';

export const type = 'complextext';
export const view = ComplexTextWidgetView;
export const editor = ComplexTextWidgetEditor;

export function builder() {
  return {
    type,
    left: 0,
    top: 0,
    rotate: 0,
    height: 100,
    width: 350,
    textAlign: 'right',
    direction: 'rtl',
    verticalAlign: 'start',
    parts: [{
      text: 'סיפור מהתזרים שהלקוחות יאהבו',
      color: '#000000',
      background: '#FFFFFF',
      fontFamily: 'SimplerPro',
      fontSize: 20,
      lineHeight: '',
    }],
  };
}
